import pkgJson from '../../../../package.json';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  app_version: pkgJson.version,

  auth0_domain: 'smarthead-test.eu.auth0.com',
  auth0_clientId: 'eG5e3Y7GiwOxyD0RyXYDhEoQu6Z13j80',
  auth0_custom_claims_prefix: 'https://dev2.besmarthead.com/',

  // api_smarthead_base_path: 'http://localhost:8000',
  // for test against dev2 environment
  api_smarthead_base_path: 'https://api-v3-dev2.besmarthead.com',
  api_smarthead_v2_base_path: 'https://api-v2-dev2.besmarthead.com',
  api_link_shortener_base_path: 'https://sh-dev2.besmarthead.com',

  // cookie
  cookies_secure: false,

  // froala licence
  froalaKey: 'SpvgxwelqC-7zxB5B-16pm==',

  // link shortener domain
  shDomain: 'https://dev2.besmarthead.com',

  // link shortener domain
  linkShortenerDomain: 'https://sh-dev2.besmarthead.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
